/*
 * rheincool — Zubehör-Panel: Reiterwechsel und Modellwähler
 * (Zubehoer-Menue-Handoff §2, §3.2).
 *
 * Reiterwechsel per Hover UND Fokus, ohne Klick — Tastatur ist gleichwertig.
 * Der Modellwähler schreibt „passend-zu" in URL und sessionStorage. Gefiltert
 * wird über die Zubehör-Metafelder; solange die nicht gepflegt sind, führt die
 * Auswahl auf die Collection mit gesetztem Parameter, ohne ein Ergebnis
 * vorzutäuschen, das es noch nicht gibt.
 */
(() => {
  'use strict';

  const SCHLUESSEL = 'rc-zubehoer-passend-zu';

  const reiter = (panel) => {
    const tabs = Array.from(panel.querySelectorAll('[data-zub-tab]'));
    const panes = Array.from(panel.querySelectorAll('[data-zub-pane]'));
    if (!tabs.length) return;

    const zeigen = (nr) => {
      tabs.forEach((t) => {
        const aktiv = t.dataset.zubTab === nr;
        t.classList.toggle('is-active', aktiv);
        t.setAttribute('aria-selected', aktiv ? 'true' : 'false');
        t.tabIndex = aktiv ? 0 : -1;
      });
      panes.forEach((p) => {
        const aktiv = p.dataset.zubPane === nr;
        p.classList.toggle('is-active', aktiv);
        p.hidden = !aktiv;
      });
    };

    tabs.forEach((t, i) => {
      t.addEventListener('mouseenter', () => zeigen(t.dataset.zubTab));
      t.addEventListener('focus', () => zeigen(t.dataset.zubTab));
      // Pfeiltasten wandern durch die Reiter, wie bei einer Tablist üblich
      t.addEventListener('keydown', (e) => {
        const schritt = { ArrowDown: 1, ArrowRight: 1, ArrowUp: -1, ArrowLeft: -1 }[e.key];
        if (!schritt) return;
        e.preventDefault();
        const ziel = tabs[(i + schritt + tabs.length) % tabs.length];
        ziel.focus();
      });
    });
  };

  const modellwahl = (box) => {
    const auswahl = box.querySelector('[data-zubehoer-select]');
    if (!auswahl) return;

    const gemerkt = new URLSearchParams(location.search).get('passend-zu')
      || sessionStorage.getItem(SCHLUESSEL);
    if (gemerkt && Array.from(auswahl.options).some((o) => o.value === gemerkt)) {
      auswahl.value = gemerkt;
    }

    auswahl.addEventListener('change', () => {
      const handle = auswahl.value;
      if (!handle) {
        sessionStorage.removeItem(SCHLUESSEL);
        return;
      }
      sessionStorage.setItem(SCHLUESSEL, handle);
      location.href = `/collections/zubehoer?passend-zu=${encodeURIComponent(handle)}`;
    });
  };

  document.querySelectorAll('[data-zubehoer-panel]').forEach((panel) => {
    reiter(panel);
    panel.querySelectorAll('[data-zubehoer-fit]').forEach(modellwahl);
  });
})();
